import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
import { authQueryKeys as r } from "@maat/store-auth";
//#region src/useOAuthLoginMutation.ts
var i = () => {
	let i = t();
	return e({
		mutationFn: n.loginWithOAuth,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: r.me() }), i.invalidateQueries({ queryKey: r.state() }), i.removeQueries({ queryKey: ["permission"] });
		}
	});
};
//#endregion
export { i as useOAuthLoginMutation };
